import { jsx } from "react/jsx-runtime";
import { Message } from "@contember/ui";
import { memo } from "react";
import { ErrorBoundary } from "react-error-boundary";
const PageErrorBoundary = memo((props) => /* @__PURE__ */ jsx(ErrorBoundary, { FallbackComponent: ProdErrorFallback, children: props.children }));
function ProdErrorFallback({}) {
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Message, { intent: "danger", size: "large", children: "Fatal error!" }) });
}
export {
  PageErrorBoundary
};
//# sourceMappingURL=PageErrorBoundary.js.map
